import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants
import { graphicDataColor1, graphicDataColor2, graphicDataColor3, graphicDataColor4 } from "../../../../../../config/constants";
// Components
import { MainDiv, Header, Title, OpenButton, OpenButtonImg } from "./styles";
import Graphic from "../../../../../graphic";
import NoDataComponent from "../../../noDataComponent";
// Assets
import ArrowUpImg from "../../../../../../assets/icons/ico_arrow_up_blue.svg";
import ArrowDownImg from "../../../../../../assets/icons/ico_arrow_down_blue.svg";

const PredictedRecoveryPlot = ({ prognosisData }) => {
  const [showPlot, setShowPlot] = useState(false);
  const [predictionsDataset, setPredictionsDataset] = useState({});
  const [t] = useTranslation("global");

  // Set dataset
  useEffect(() => {
    const trajectoryPredictions = [
      "Trajectory_estimated",
      "Trajectory_ci95_low",
      "Trajectory_ci95_high",
      "Trajectory_ci68_low",
      "Trajectory_ci68_high",
    ];
    const parsedPredictions = prognosisData.filter((prediction) => trajectoryPredictions.includes(prediction.PROGNOSIS_PREDICTION_KEY));

    let predictions = {
      Trajectory_estimated: [],
      Trajectory_ci95_low: [],
      Trajectory_ci95_high: [],
      Trajectory_ci68_low: [],
      Trajectory_ci68_high: [],
    };

    for (const prediction of parsedPredictions) {
      predictions[prediction.PROGNOSIS_PREDICTION_KEY] = prediction.PROGNOSIS_PREDICTION_VALUE.split(",").map(Number);
    }

    const FUGL_MEYER_VALUES = prognosisData.filter((assessment) => assessment.PROGNOSIS_PREDICTION_KEY === "Trajectory_measured");

    const measuredFM = FUGL_MEYER_VALUES.map((fm) => {
      const [x, y] = fm.PROGNOSIS_PREDICTION_VALUE.replace(/[()]/g, "").split(",").map(Number);
      return {
        y,
        x,
      };
    });

    const predictedRecoveryWeeks = Array.from({ length: predictions.Trajectory_estimated.length }, (_, i) => i + 1);

    const predictedTrajectoryData = {
      labels: predictedRecoveryWeeks,
      datasets: [
        {
          label: t("advancedAnalytics_trajectoryPlot_label1"),
          data: measuredFM,
          backgroundColor: [graphicDataColor4],
          borderColor: [graphicDataColor4],
          pointRadius: 10,
          borderWidth: 3,
          showLine: false,
          pointStyle: "cross",
        },
        {
          label: t("advancedAnalytics_trajectoryPlot_label2"),
          data: predictions.Trajectory_estimated,
          backgroundColor: [graphicDataColor1],
          borderColor: [graphicDataColor1],
        },
        {
          label: t("advancedAnalytics_trajectoryPlot_label3"),
          data: predictions.Trajectory_ci95_low,
          backgroundColor: [graphicDataColor2],
          borderColor: [graphicDataColor2],
          pointRadius: 0,
          borderWidth: 1,
        },
        {
          label: t("advancedAnalytics_trajectoryPlot_label3"),
          data: predictions.Trajectory_ci95_high,
          backgroundColor: [graphicDataColor2],
          borderColor: [graphicDataColor2],
          pointRadius: 0,
          borderWidth: 1,
        },
        {
          label: t("advancedAnalytics_trajectoryPlot_label4"),
          data: predictions.Trajectory_ci68_low,
          backgroundColor: [graphicDataColor3],
          borderColor: [graphicDataColor3],
          pointRadius: 0,
          borderWidth: 1,
        },
        {
          label: t("advancedAnalytics_trajectoryPlot_label4"),
          data: predictions.Trajectory_ci68_high,
          backgroundColor: [graphicDataColor3],
          borderColor: [graphicDataColor3],
          pointRadius: 0,
          borderWidth: 1,
        },
      ],
    };

    setPredictionsDataset(predictedTrajectoryData);

    return () => {
      setPredictionsDataset({});
    };
  }, [prognosisData, t]);

  return (
    <MainDiv>
      <Header>
        <Title>Predicted recovery trajectory</Title>
        <OpenButton onClick={() => setShowPlot(!showPlot)}>
          <OpenButtonImg src={showPlot ? ArrowUpImg : ArrowDownImg} alt="arrow-ico" />
        </OpenButton>
      </Header>
      {showPlot &&
        (Boolean(prognosisData.length) ? (
          <Graphic
            Title={""}
            Type={Line}
            data={predictionsDataset}
            axisY={"FM-UE"}
            axisX={"Weeks since stroke"}
            max={66}
            margin="0"
            height="250px"
          />
        ) : (
          <NoDataComponent />
        ))}
    </MainDiv>
  );
};

export default PredictedRecoveryPlot;
